import React, { useCallback, useContext } from "react"
import { useTranslation } from "react-i18next"
// import Select  from "@mui/material/Select"
import Select, { components, CSSObjectWithLabel, OnChangeValue, Props as SelectProps } from "react-select"
import { CustomFieldContext } from "../contexts/CustomConfigContext"

export interface MultiSelectValue {
    label: string
    value: string
    hint?: string
    keyLabel?: string
    keyHint?: string
}

export interface MultiSelectProps extends Omit<SelectProps<MultiSelectValue, false>, "onChange"> {
    id?: string
    readonly?: boolean
    onChange?: (value?: string) => void
}

export function MultiSelect({ id, onChange, readonly, isClearable, ...rest }: MultiSelectProps) {
    const customFieldContext = useContext(CustomFieldContext)
    const disabledCustom = customFieldContext?.disabled ?? readonly
    const { t } = useTranslation()

    const Option = (props: any) => (
        <>
            <components.Option {...props}>
                {t(props.data.keyLabel)}
                {props.data.hint ? (
                    <p className="mb-0">
                        <small className="text-danger">{t(props.data.hint)}</small>
                    </p>
                ) : null}
            </components.Option>
        </>
    )

    const onChangeHandler = useCallback<(value: OnChangeValue<MultiSelectValue, false>) => void>(
        (value) => {
            if (onChange && !Array.isArray(value)) {
                onChange(value?.value)
            }
        },
        [onChange],
    )

    return (
        <Select<MultiSelectValue, false>
            inputId={id}
            styles={{
                placeholder: (base: CSSObjectWithLabel) => ({ ...base, opacity: 0.4 }),
                control: (base, props) => {
                    if (props.isFocused) {
                        return { ...base, borderColor: "#80bdff", color: "#495057", outline: "0", boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)" }
                    }
                    return { ...base, borderColor: "#ced4da !important", color: "#495057" }
                },
            }}
            isClearable={isClearable ?? false}
            isDisabled={disabledCustom}
            noOptionsMessage={() => "Keine Ergebnisse gefunden"}
            onChange={onChangeHandler}
            components={{ Option }}
            {...rest}
        />
    )
}
